import {
    FormControl,
    Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
    autoCompleteSelectOptionsFormat,
    extractDataGroup,
    extractSelectedValues,
    selectedListValues,
} from "../../../../../utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoCompleteV1 from "shared-component/autocomplete-checkbox-multiple-v1";
import { useState } from "react";

dayjs.extend(utc);

const ProductionFacility = (props: any) => {
    const [plantName, setPlantName] = useState<string[]>(extractDataGroup(props.unNestedParamData, "plantName") ??  []);
    const [lineOffDate, setLineOffDate] = useState<string[]>(extractDataGroup(props.unNestedParamData, "line_of_date") ?? []);

    const handleSelection = (selectedList: listItemProp[], filter: string) => {
        const value: string[] = selectedListValues(selectedList);
        switch (filter) {
            case 'plantName':
                setPlantName(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
            case 'line_of_date':
                setLineOffDate(value);
                props.getUpdatedList({
                    title: filter,
                    value: value,
                });
                break;
        }

    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={plantName?.length > 0 ? plantName?.toString() : "Select / Search Plant Name"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.plantName)}
                        label="Select / Search Plant Name"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "plantName")
                        }}
                        
                        selectedValues={extractSelectedValues(plantName)}
                        disabled={props.plantName?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
        <div className="signalFilterList" style={{ padding: "8px" }}>
            <Tooltip title={lineOffDate?.length > 0 ? lineOffDate?.toString() : "Select / Search Line Off Date"} placement="right">
                <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                    <MultiSelectAutoCompleteV1
                        items={autoCompleteSelectOptionsFormat(props?.lineOffDate)}
                        label="Select / Search Line Off Date"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleCANSignalSelection(value)
                            handleSelection(value, "lineOffDate")
                        }}
                        
                        selectedValues={extractSelectedValues(lineOffDate)}
                        disabled={props.lineOffDate?.length === 0}
                    />
                </FormControl>
            </Tooltip>
        </div>
    </div>
    );
};



export default ProductionFacility;
